export default "__VITE_ASSET__d7c049ee__"